/* Tells Prism, before it loads, not to highlight the whole page by itself.
   Prism reads window.Prism.manual once, while its core module is evaluated,
   and ES imports run in order, so this file is imported first in
   code-highlight.js. Highlighting then happens only where that module asks. */
window.Prism = window.Prism || {};
window.Prism.manual = true;
